import {
    TreatmentDTO,
    TreatmentEntryType,
    TreatmentModel
} from "../../home/components/treatment-management/treatment.types";
import {
    ToothConditionDTO,
    getLocalizationText,
    MouthConditionDTO,
    ToothConditionResponse, ConditionDTO
} from "../../tooth-chart/tooth/tooth.types";
import {translate} from "@ngneat/transloco";
import {AuditDTO} from "../../../shared/components/audit/audit.types";
import {Note} from "../../../shared/components/notes/notes.types";

export class InterventionStatistics{
    OPEN: number;
    IN_PAYMENT: number;
    CLOSED: number;
}

export class UpdateEntities{
    constructor(public entities: string[]){}
}

export class LinkEventsToInterventionsReq{
    constructor(public interventionIds: string[], public eventIds: string[]){}
}

export class CalEvt{
    eventId: string;
    startTime: string|number[];
    endTime: string|number[];
    description: string;
}

export enum InterventionState{
    OPEN="OPEN", IN_PAYMENT="IN_PAYMENT", CLOSED="CLOSED"
}

export class InterventionModel extends AuditDTO
{
    id: string | null;
    treatments: TreatmentModel[];
    attachedToCalendarEvents:CalEvt[];
    mouthAppliedMouthCondition: MouthConditionDTO;
    toothAppliedCondition: ToothConditionDTO
    interventionState: InterventionState;
    patientId: string;
    doctorId: string;
    title: string;
    description?: string | null;
    notes: Note[];
}


export class InterventionModelToCreate
{
    patientId: string;
    doctorId:string;
    events: string[];
    mouthAppliedCondition: string;
    toothAppliedCondition: string;
    treatments:string[];
    title: string;
    description?: string;
}

export class InterventionModelToUpdate
{
    id: string;
    title: string;
    description?: string;
    doctorId?:string;
}

export class BulkTreatmentUpdateReq {
    treatment: TreatmentModel;
    entities: UpdateEntities;
}

export interface ICard
{
    id: string | null;
    listId: string;
    position: number;
    filtered:boolean;

    title: string;
    subtitle?: string;
    underIconTxt?: string;
    price?: number;
    description?: string | null;
    locationStr?: string | null;
    icon?: string | null;
    createdDate?: any | null;
    recall?: string | null;
    type: TreatmentEntryType;
}

// -----------------------------------------------------------------------------------------------------
// @ Card
// -----------------------------------------------------------------------------------------------------
export class Card implements Required<ICard>
{
    id: string | null;
    listId: string;
    position: number;
    filtered: boolean;

    title: string;
    subtitle: string;
    underIconTxt: string;
    price: number;
    description: string | null;
    locationStr: string | null;
    icon: string | null;
    createdDate: any | null;
    recall: string | null;
    type: TreatmentEntryType;

    /**
     * Constructor
     */
    constructor(card: ICard)
    {
        this.id = card.id || null;
        this.listId = card.listId;
        this.position = card.position;
        this.filtered = card.filtered;

        this.title = card.title;
        this.subtitle = card.subtitle || null;
        this.underIconTxt = card.underIconTxt || null;
        this.price = card.price || null;
        this.description = card.description || null;
        this.locationStr = card.locationStr || null;
        this.icon = card.icon || null;
        this.createdDate = card.createdDate || null;
        this.recall = card.recall || null;
        this.type = card.type || TreatmentEntryType.Treatment;
    }
}

export function getCardFromToothConditionResponse(problem: ToothConditionResponse, listID:string, position:number):Card {
    let localizationStr:string = getLocalizationText(problem.toothConditionResponseDTO.teethLocalization).toUpperCase();
    let description:string = problem?.toothConditionResponseDTO?.condition?.description;

    return new Card({
        id: problem.toothConditionResponseDTO.id,
        listId: listID,
        position: position,
        title: problem?.toothConditionResponseDTO?.condition?.summary,
        subtitle: problem?.toothConditionResponseDTO?.condition?.category,
        filtered: false,
        underIconTxt: problem.teethDTO.toothBlock + ''+ problem.teethDTO.toothOffset,
        createdDate: problem.toothConditionResponseDTO.createdOn,
        icon: problem.toothConditionResponseDTO.condition.icon,
        description: description,
        locationStr: localizationStr,
        type: TreatmentEntryType.Condition
    });
}

export function getCardFromAppliedTreatment(treatment: TreatmentModel, listID:string, position:number):Card {
    let recallData = "";
    if(treatment?.hasExpirationData()){
        recallData = recallData + (treatment.getExpirationData()[0] > 0 ? treatment.getExpirationData()[0]+" "+translate('days')+" ":"");
        recallData = recallData + (treatment.getExpirationData()[1] > 0 ? treatment.getExpirationData()[1]+" "+translate('hours')+" ":"");
        recallData = recallData + (treatment.getExpirationData()[2] > 0 ? treatment.getExpirationData()[2]+" "+translate('minutes'):"");
    }else{
        recallData = null;
    }

    let localizationStr:string = "";
    const description:string = treatment.getDescription();

    return new Card({
        id: treatment.getID(),
        listId: listID,
        position: position,
        title: treatment.getSummary(),
        subtitle: treatment.getCategory(),
        filtered: false,
        underIconTxt: "",
        createdDate: null,
        icon: treatment.getIcon(),
        description: description,
        locationStr: localizationStr,
        type: TreatmentEntryType.Treatment,
        price: treatment.getCost(),
        recall: recallData
    });
}

